import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [
          _c(VSpacer),
          _vm.monitoramento === "mapeamento"
            ? _c(
                VCol,
                { attrs: { cols: "4" } },
                [
                  _c("app-select-mapeamento", {
                    attrs: {
                      mapeamento: _vm.mapeamento,
                      mapeamentos: _vm.mapeamentos,
                    },
                    on: { return: (value) => (_vm.mapeamento = value) },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.monitoramento === "diagnostico" ||
          _vm.monitoramento === "desempenho"
            ? _c(
                VCol,
                { attrs: { cols: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      items: _vm.diagnosticos,
                      "item-text": "nome",
                      "item-value": "id",
                      label: "Diagnóstico:",
                      "return-object": "",
                    },
                    model: {
                      value: _vm.diagnostico,
                      callback: function ($$v) {
                        _vm.diagnostico = $$v
                      },
                      expression: "diagnostico",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { title: "Informações" } }, [
                _c(
                  "div",
                  { attrs: { slot: "widget-content" }, slot: "widget-content" },
                  [
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.labelMonitoramento) + ": "),
                          ]),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(_vm._s(_vm.nomeMonitoramento)),
                          ]),
                        ]),
                        _vm.monitoramento === "diagnostico" && _vm.diagnostico
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Período: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(_vm._s(_vm.periodoDiagnostico)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.monitoramento === "perfil"
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Unidade: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(
                                    `${_vm.unidade.sigla} - ${_vm.unidade.nome}`
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card-widget",
                {
                  attrs: {
                    "enable-actions": _vm.actions,
                    title: _vm.titulo ? _vm.titulo : "Relatório",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      attrs: { slot: "widget-content" },
                      slot: "widget-content",
                    },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      {
                                        attrs: {
                                          absolute: "",
                                          color: "secondary",
                                          dark: "",
                                          fab: "",
                                          right: "",
                                          top: "",
                                        },
                                        on: { click: _vm.loadTutorial },
                                      },
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("help")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v("Em caso de dúvidas, clique aqui"),
                          ]),
                        ]
                      ),
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [_vm._t("body")],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      attrs: { slot: "widget-actions" },
                      slot: "widget-actions",
                    },
                    [
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [_vm._t("actions")],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }